import { useEffect, useState } from 'react';
import { Container, Grid } from '@mui/material';
import CustomLoader from 'src/components/loader/loader';
import SettingLogicForm from 'src/components/form/settingLogicForm';
import TabTitle from 'src/components/tabTitle/tabTitle';
import PageHeader from 'src/components/pageHeader/PageHeader';
import { showErrorTost, showSuccessTost } from 'src/constants';
import { GET_SETTING, UPDATE_SETTING } from 'src/apiService/apiDeclaration';

const SettingPage = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ loading: true });

  const getData = async () => {
    try {
      const resp = await GET_SETTING();
      setData(resp.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  const onUpdateSetting = async (data) => {
    console.log(data);
    if (loading) return;
    setLoading(true);
    try {
      const resp = await UPDATE_SETTING(data);
      if (resp) {
        showSuccessTost('Setting successfully updated!!!');
        setLoading(false);
      }
    } catch (err) {
      showErrorTost('Error in updating setting!!!');
      setLoading(false);
    }
  };
  return (
    <Container>
      <Grid container spacing={2}>
        <TabTitle title={'Settings'} />
        <Grid item xs={12}>
          <PageHeader pageTitle={'Core Price Settings'} />
        </Grid>

        <Grid item xs={12}>
          {data.loading ? (
            <CustomLoader />
          ) : (
            <SettingLogicForm data={data} onSubmit={onUpdateSetting} loading={loading} />
          )}
        </Grid>
      </Grid>
    </Container>
  );
};
export default SettingPage;
